import { PERMISSIONS, can } from "../permissions/index.js";

const { PRODUCT_SET_FIXED_BUMP: SET, PRODUCT_CLEAR_FIXED_BUMP: CLEAR } =
  PERMISSIONS;

const IN_PERSON_SIGNING = "In Person Signing";

const isInPerson = ({ signedType }) => signedType === IN_PERSON_SIGNING;

const createActions = (requested) =>
  isInPerson(requested) || requested.fixedBump ? [SET] : [];

const turnOffAction = (existing) => (isInPerson(existing) ? SET : CLEAR);

const updateActions = (existing, requested) => {
  const turnedOff = existing.fixedBump && !requested.fixedBump;
  const turnedOnOrRepriced =
    requested.fixedBump &&
    (!existing.fixedBump || existing.productBump !== requested.productBump);

  if (turnedOff) return [turnOffAction(existing)];
  return turnedOnOrRepriced ? [SET] : [];
};

export const bumpActionsFor = ({ existing, requested }) =>
  existing ? updateActions(existing, requested) : createActions(requested);

export const duplicateActionsFor = (target) =>
  isInPerson(target) ? [SET] : [];

export const dropsFixedBumpOnDuplicate = ({ parent, identity }) =>
  Boolean(parent.fixedBump) && !can(SET, parent, identity);
